import { AfterViewInit, DestroyRef, Directive, ElementRef, inject, output } from '@angular/core';

@Directive({
  selector: '[recrewtDetectOverflow]',
  host: {
    '(scroll)': 'onScroll()',
  },
})
export class DetectOverflowDirective implements AfterViewInit {
  private el = inject(ElementRef<HTMLElement>);

  private destroyRef = inject(DestroyRef);

  readonly overflowChange = output<boolean>();

  // ResizeObserver also catches content growth (async data, font loads), which a
  // window:resize listener alone would miss.
  private resizeObserver?: ResizeObserver;

  ngAfterViewInit() {
    this.check();
    this.resizeObserver = new ResizeObserver(() => this.check());
    this.resizeObserver.observe(this.el.nativeElement);
    this.destroyRef.onDestroy(() => this.resizeObserver?.disconnect());
  }

  check() {
    const element = this.el.nativeElement;
    const isOverflowing = element.scrollHeight > element.clientHeight;
    this.overflowChange.emit(isOverflowing);
  }

  onScroll() {
    const element = this.el.nativeElement;
    const isAtBottom = element.scrollTop + element.clientHeight >= element.scrollHeight;
    this.overflowChange.emit(!isAtBottom);
  }
}
